import i18n from '../../utils/i18n'

export const PackagingIdentifierBodyTemplate = (packagingIdentifier: any) => {
  if (!packagingIdentifier) return null

  return (
    <>
      {i18n.t(
        `masterDataManagement.packagingData.table.columns.packagingIdentifier.options.${packagingIdentifier}`,
      )}
    </>
  )
}
